import { CgEye } from "react-icons/cg";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import styled from "styled-components/macro";
import { useNavigate } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Check";
import { Grid, Avatar, IconButton, Tooltip } from "@mui/material";

import {
  HeadingEighteen,
  TextFourteenBlack,
  colors,
} from "../../css components/Style";
import { Paper } from "../../../components";
import { useAxios, useAlert } from "../../../hooks";
import pages from "../../../constants/pages";
import Dialog from "../../../components/Dialog";

let siteColors = JSON.parse(sessionStorage.getItem("siteColors"));

const Icon = styled(IconButton)`
  border: 1px solid ${siteColors?.primary};
  color: ${siteColors?.primary};
  height: 35px;
  width: 35px;
  margin: 0 5px;
  padding: 0 5px;
  &:hover {
    border: 1px solid ${siteColors?.primary};
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  }
`;

const Check = styled(CheckIcon)`
  color: #28967e;
  border-radius: 5px;
  border: 3px solid;
  font-size: x-large;
  margin-top: 5px;
`;

const Close = styled(CloseIcon)`
  color: #d32f2f;
  border-radius: 5px;
  border: 3px solid;
  font-size: x-large;
  margin-top: 5px;
`;

export default function List({ agencies, setAgencyStatus }) {
  const axios = useAxios();
  const { alert } = useAlert();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [dialogState, setDialogState] = useState({
    state: false,
    data: {},
  });

  function handleAgencyNavigation(agencyID) {
    navigate(pages.unverifiedAgenciesDetails.route + "?agencyID=" + agencyID);
  }

  return (
    <Grid container spacing={3}>
      {agencies.map((agency) => (
        <Grid item xs={12}>
          <Paper>
            <Grid item xs={1}>
              <Avatar
                onClick={() => handleAgencyNavigation(agency.agency_id)}
                src={agency.logo}
                style={{ height: "60px", width: "60px", cursor: "pointer" }}
              />
            </Grid>

            <Grid item xs={2}>
              <TextFourteenBlack>Agency Name</TextFourteenBlack>
              <HeadingEighteen>
                {agency.agency_name.replace(/_/g, " ") || "-"}
              </HeadingEighteen>
            </Grid>

            <Grid item xs={2}>
              <TextFourteenBlack>Agency Status</TextFourteenBlack>
              <HeadingEighteen
                style={{
                  color:
                    agency.agency_verification_status === 0
                      ? colors.yellow
                      : agency.agency_verification_status === 1
                      ? colors.green
                      : colors.error,
                }}
              >
                {agency.agency_verification_status === 0 && "Unverified"}
                {agency.agency_verification_status === 1 && "Verified"}
                {agency.agency_verification_status === 2 && "Rejected"}
              </HeadingEighteen>
            </Grid>

            <Grid item xs={2}>
              <TextFourteenBlack>Agency Detail</TextFourteenBlack>

              <HeadingEighteen>
                <Check
                  sx={{
                    marginLeft: "35px",
                  }}
                />
              </HeadingEighteen>
            </Grid>

            <Grid item xs={2}>
              <TextFourteenBlack>Company Detail</TextFourteenBlack>

              <HeadingEighteen
                style={{
                  color:
                    agency.is_company_detail_filled === 0
                      ? colors.yellow
                      : colors.green,
                }}
              >
                {agency.is_company_detail_filled === 1 ? (
                  <Check
                    sx={{
                      marginLeft: "45px",
                    }}
                  />
                ) : (
                  <Close
                    sx={{
                      marginLeft: "45px",
                    }}
                  />
                )}
              </HeadingEighteen>
            </Grid>

            <Grid item xs={2} />
            <Grid
              item
              xs={1}
              alignSelf={"center"}
              display="flex"
              justifyContent={"end"}
            >
              <Tooltip title="View Agency">
                <Icon>
                  <CgEye
                    onClick={() => handleAgencyNavigation(agency.agency_id)}
                    style={{ height: "20px", width: "20px" }}
                  />
                </Icon>
              </Tooltip>
            </Grid>
          </Paper>
        </Grid>
      ))}

      <Dialog
        dialogState={dialogState}
        setDialogState={setDialogState}
        handleAgree={handleAgree}
        dialogContent={{
          title: "Do You want to reject this brand?",
          dangerButton: "Reject Brand",
        }}
      />
    </Grid>
  );
  function handleAgree(brand, status) {
    handleAction(dialogState.data?.brand, dialogState.data?.status);
  }

  function handleAction(brand, status) {
    axios({
      url: "/brand/verification/action",
      method: "POST",
      disableRedirect: true,
      data: {
        brand_id: brand.brand_id,
        brand_status: status,
      },
    }).then((response) => {
      if (response.status) {
        setAgencyStatus(brand.brand_id);
        dispatch(
          alert({
            message: response.message.displayMessage,
            type: "success",
          })
        );
      }
    });
  }
}
